import { Box, Paragraph } from 'grommet'
import Image from 'next/image'
import styled, { css } from 'styled-components'

export const Wrapper = styled(Box)`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 15px;
  justify-content: center;

  ${({ theme }) => theme.below.mobileXL`
    margin-bottom: ${theme.newSpaces.sm}px;
  `}
`

export const ImageWrapper = styled(Box)`
  border-radius: 100px;
  height: 88px;
  width: 88px;

  ${({ theme }) => css`
    background-color: ${theme.newColors.lightGray};

    ${theme.below.mobileXL`
      height: 60px;
      width: 60px;
    `}
  `}
`

export const AvatarImage = styled(Image)`
  border-radius: 100px;
  display: block;
  height: 100%;
  width: 100%;
`

export const TextWrapper = styled(Box)`
  display: flex;
  justify-content: space-evenly;
`

export const Title = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')};

    color: ${theme.newColors.primary};
    margin-bottom: ${theme.newSpaces.xs2}px;

    ${({ theme }) => theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title1')};

      line-height: 34px;
    `}
  `}
`

export const Description = styled(Paragraph)`
  max-width: none;
  min-width: 100%;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body1')};

    color: ${theme.newColors.primary};

    ${({ theme }) => theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body2')};
    `}
  `}
`
